import { Component, ViewChild } from '@angular/core';
import { Registration, ControlRegistration } from 'src/app/shared/models/registration';
import { alert } from 'devextreme/ui/dialog';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { HoursOption } from 'src/app/shared/models/hours-option';
import { Worker } from 'src/app/shared/models/worker';
import { Subject, takeUntil } from 'rxjs';
import { KindOfWork } from '../../shared/models/kind-of-work';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';
import { RegistrationWorkflowService, WorkflowContext } from '../../shared/services/registration-workflow.service';


@Component({
    selector: 'app-registration-controls',
    templateUrl: './registration-controls.component.html',
    styleUrl: './registration-controls.component.scss',
    standalone: false
})
export class RegistrationControlsComponent {
  registration!: Registration | undefined;
  selectedControls: ControlRegistration[] = [];
  option: HoursOption | any;
  currentWorker: Worker | undefined;
  dataSource: any;
  ControlliNote: any;

  @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

  private unsubscribe: Subject<void> = new Subject<void>();


  constructor(
    private service: WorkerAndToolService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router,
    private workflowService: RegistrationWorkflowService) {

    this.setCellValueNEG = this.setCellValueNEG.bind(this);
    this.setCellValuePOS = this.setCellValuePOS.bind(this);
  }


  ngOnInit() {
    this.toolbar.backClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Back());
    this.toolbar.forwardClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Forward());

    this.service.getCurrentWorkerObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.currentWorker = val;
    });
    

    this.service.getHoursOptionObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.option = val;
    });

    this.toolbar.BackVisibleChanged(true);
    this.toolbar.SaveVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(true);
    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);

    let regId = this.route.snapshot.paramMap.get('id');

    if (regId == null) {
      regId = "-1";
    }

    this.service.getTempRegistration(Number(regId)).then((reg) => {
      this.registration = reg;
      if (this.registration) {

        this.service.getSelectedControlsRegistrations(this.registration).then((s) => {
          this.selectedControls = s;
          this.dataSource = {
            store: this.selectedControls,
            key: 'ControlDoneID'
          };
        });

      }
    });
  }

  setCellValuePOS(newData: any, value: boolean, currentRowData: ControlRegistration) {
    newData.selectedNeg = false;
    newData.selectedPos = value;
  }

  setCellValueNEG(newData: any, value: boolean, currentRowData: ControlRegistration) {
    newData.selectedNeg = value;
    newData.selectedPos = false;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  Forward() {
    this.grid.instance.saveEditData().then(() => this.saveRegistration());
  }

  Back() {
    if (this.registration) {
      const ctx: WorkflowContext = { options: this.option, siteManagerMode: !!this.currentWorker?.siteManagerMode, hasControls: true };
      const prev = this.workflowService.getPreviousStep('registration-controls', ctx);
      if (prev) {
        this.service.editTempRegistration(this.registration, this.registration.id ?? 0)
          .then((regId) => this.router.navigate(['/' + prev, { id: regId }]));
      } else {
        this.router.navigate(['/registration']);
      }
    }
  }

  private saveRegistration() {
    if (this.registration) {

      const currentSelectedRegistrations = this.selectedControls; // così ho tutti i controlli

      // clearing della lista dei controlli
      this.registration.controlsRegistration = [];



        for (let i = 0; i < this.selectedControls.length; i++) {

          // 0 = NEG
          // 1 = POS
          // 2 = NULL / Non Valid / ecc...

          let statusCheck;
          if (this.selectedControls[i].selectedPos && this.selectedControls[i].selectedNeg) {
            statusCheck = 2;
          } else {
            if (this.selectedControls[i].selectedPos) {
              statusCheck = 1;
            }
            else if (this.selectedControls[i].selectedNeg) {
              statusCheck = 0;
            }
            else {
              statusCheck = 2;
            }
          }

         
            this.registration.controlsRegistration.push(
              {
                checkedV: statusCheck,
                controlID: this.selectedControls[i].controlID,
                description: this.selectedControls[i].description,
              }

            );
        }
        //this.registration.noteControlli = this.ControlliNote;

      this.registration.noteControlli;




      const ctx: WorkflowContext = { options: this.option, siteManagerMode: !!this.currentWorker?.siteManagerMode, hasControls: true };

      if (this.workflowService.isFinalStep('registration-controls', ctx)) {
        const registrationId = this.registration.id ?? 0;
        if (registrationId > 0) {
          this.service.editRegistration(this.registration, registrationId)
            .then(() => this.router.navigate(['/registrations']));
        } else {
          this.service.addRegistration(this.registration)
            .then(() => this.router.navigate(['/registrations']));
        }
      } else {
        this.service.editTempRegistration(this.registration, this.registration.id ?? 0).then((regId) => {
          const next = this.workflowService.getNextStep('registration-controls', ctx);
          this.router.navigate(['/' + next, { id: regId }]);
        });
      }

      }
    }


}
